<template>
	<div class="business-auth-wrap">
		<!-- 新增授权区域 -->
		<el-form :model="form" inline label-width="80px">
			<el-form-item label="菜单编码">
				<el-select v-model="form.menuCode" placeholder="请选择业务菜单" clearable @change="forOrgList">
					<el-option v-for="item in BusinessList" :key="item.menuCode" :label="item.menuName"
						:value="item.menuCode">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="机构类型">
				<el-select v-model="form.orgType" @change="getMenuBusinessList">
					<el-option label="学校" value="学校"></el-option>
					<el-option label="教育局" value="教育局"></el-option>
				</el-select>
			</el-form-item>
			
			<el-form-item label="机构ID">
				<el-select v-model="form.orgId" placeholder="请选择机构" clearable >
					<el-option v-for="item in orgList" :key="item.id" :label="item.schoolName"
						:value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="授权过期">
				<el-date-picker v-model="form.expireTime" type="datetime" placeholder="选择过期时间"></el-date-picker>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="submitAuth">新增授权</el-button>
			</el-form-item>
		</el-form>

		<!-- 授权列表 -->
		<el-table :data="tableData" border class="mt-20" style="width: 100%">
			<el-table-column prop="id" label="ID" width="80" align="center" />
			<el-table-column prop="menuCode" label="菜单编码" align="center" />
			<el-table-column prop="orgType" label="机构类型" align="center" />
			<el-table-column prop="orgId" label="机构ID" align="center" />
			<el-table-column prop="status" label="状态" align="center">
			<template slot-scope="props">
			    {{props.row.status==1?'正常':"删除"}}
			</template>
			</el-table-column>
			<el-table-column prop="expireTime" label="授权过期时间" align="center" />
			<el-table-column label="操作" align="center" width="100">
				<template slot-scope="props">
					<el-button type="text" icon="el-icon-delete" v-if="props.row.status!=10" @click="handleDel(props.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
	import {
		getMenuBusinessList,
		authBusiness,
		getBusinessList,
		delBusinessAuth
	} from './memu.js'
	export default {
		name: 'BusinessAuth',
		data() {
			return {
				tableData: [],
				form: {
					menuCode: '',
					orgType: '学校',
					orgId: '',
					expireTime: ''
				},
				BusinessList: [],
				orgList: [],
			}
		},
		mounted() {
			this.loadTableData()
		},
		methods: {
			async togetMenuBusinessList(val) {
				let res = await getMenuBusinessList(val)
				this.BusinessList = res.data.data
			},
			async forOrgList(val){
				const res = await getBusinessList(val)
				this.tableData = res.data.data
			},
			async getList() {
				this.loading = true;
				const params = {
					pageNum: 1,
					pageSize: 100,

				};
				const res = await this.API.get(this.API.admin.getSchoolList, {
					...params
				});
				this.orgList = res.data.data.records;
			},
			async loadTableData() {
				await this.togetMenuBusinessList(this.form.orgType)
				if (this.form.orgType == '学校') {
					await this.getList()
				}
				
			},
			// 新增授权
			async submitAuth() {
				if (!this.form.menuCode || !this.form.orgId || !this.form.expireTime) {
					this.$message.warning('请完善必填项')
					return
				}
				await authBusiness(this.form)
				this.$message.success('授权成功')
				this.form = {
					menuCode: '',
					orgType: '学校',
					orgId: '',
					expireTime: ''
				}
				this.loadTableData()
			},
			// 删除授权
			handleDel(row) {
				this.$confirm('确定取消该业务授权？', '提示', {
						type: 'warning'
					})
					.then(async () => {
						await delBusinessAuth(row.id)
						this.$message.success('删除成功')
						this.loadTableData()
					})
			}
		}
	}
</script>

<style scoped>
	.mt-20 {
		margin-top: 20px;
	}
</style>